import {
  MasterDataFreeShiftItem,
  //MasterDataFreeShiftListResponse,
  DetailsDataResponse, PgDataResponse, ArbeitenDataResponse
} from '@/types/service-response'
import { FreeShiftDetails } from '@/model/master-data/FreeShiftDetails'
import { FreeShiftWork } from '@/model/master-data/FreeShiftWork'
import { FreeShiftPlanningGroup } from '@/model/master-data/FreeShiftPlanningGroup'
import { ShiftBreak } from '@/model/master-data/ShiftBreak'
import moment from 'moment'

export class FreeShift {
  public constructor (
    readonly id: number | undefined,
    readonly code: string,
    readonly description: string,
    readonly start: string,
    readonly end: string,
    readonly budget: number,
    public color: string,
    readonly planningGroupData: Array<FreeShiftPlanningGroup>,
    public workData: Array<FreeShiftWork>,
    readonly isActive: boolean,
    readonly shiftBreakList: ShiftBreak[],
    readonly duration: string
  ) {}

  static createListFromResponse (data: MasterDataFreeShiftItem): Array<FreeShift> {

    const result: Array<FreeShift> = data.freeshiftDetailsData.map((item: DetailsDataResponse) => {
      let start: string = item.Start.split(' ')[0]
      let end: string = item.Ende.split(' ')[0]
      const shift: FreeShiftDetails = {
        id: item.ID,
        code: item.Code,
        description: item.Bezeichnung,
        start: start,
        end: end,
        budget: item.Budget,
        color: item.Farbe,
      }

      let planningGroupData: Array<FreeShiftPlanningGroup> = []
      data.freeshiftPGData.forEach((i: PgDataResponse) => {
        if (i.IDShif === item.ID) {
          planningGroupData.push({
            shiftId: i.IDShif,
            planningGroupId: i.Schichten_PlanungsgruppeId,
            numberOfEmployees: i.Anzahl,
            comment: i.Bemerkungen,
            departments: i.Abteilungen,
            planningGroup: i.Planungruppe,
            departmentsDesignation: i.AbteilungenBezeichnung,
            planningGroupName: i.PlanungsgruppeName,
            offset: i.Offset
          })
        }
      })

      let workData: Array<FreeShiftWork> = []
      data.freeshiftArbeitenData.forEach((i: ArbeitenDataResponse) => {
        if (i.IDShif === item.ID) {
          workData.push(new FreeShiftWork(
            i.IDShif,
            i.Schichten_PlanungsgruppeId,
            i.Schichten_QCQID,
            i.Arbeit,
            i.ArbeitBezeichnungCode,
            i.Plannungsgruppe,
            i.alreadyinsert,
            i.Offset,
            undefined
        ))
        }
      })

      let shiftBreakList: ShiftBreak[] = ShiftBreak.createFromResponse(item.SchichtenPausenData)
      let duration: string = ''
      if(shift.start && shift.end) {
        let startDuration: number = (moment(shift.start, 'HH:mm').hour() * 60) + moment(shift.start, 'HH:mm').minutes()
        let endDuration: number = (moment(shift.end, 'HH:mm').hour() * 60) + moment(shift.end, 'HH:mm').minutes()
        let shiftDuration: number = endDuration - startDuration

        shiftBreakList.forEach((item: ShiftBreak) => {
          if(item.startBreak && item.endBreak) {
            let startDuration: number = (moment(item.startBreak, 'HH:mm').hour() * 60) + moment(item.startBreak, 'HH:mm').minutes()
            let endDuration: number = (moment(item.endBreak, 'HH:mm').hour() * 60) + moment(item.endBreak, 'HH:mm').minutes()
            let pauseDuration: number = endDuration - startDuration
            shiftDuration = shiftDuration - pauseDuration
          }
        })

        duration = moment.utc(shiftDuration *60 * 1000).format('HH:mm')
      }

      return new FreeShift(
        shift.id,
        shift.code,
        shift.description,
        shift.start,
        shift.end,
        shift.budget,
        shift.color,
        planningGroupData,
        workData,
        item.Aktiv,
        shiftBreakList,
        duration
      )
    })
    return result
  }
}